"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * session-manager-lambda openapi
 * API gateway for session-manager-lambda
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStateStatusEnum = exports.SessionStateLinearPlaybackTerminateTimeReasonEnum = void 0;
exports.SessionStateLinearPlaybackTerminateTimeReasonEnum = {
    AuthenticationExpired: 'authenticationExpired',
    BadArgument: 'badArgument',
    BadConfiguration: 'badConfiguration',
    Deprecated: 'deprecated',
    ExternalError: 'externalError',
    HostUnavailable: 'hostUnavailable',
    InternalError: 'internalError',
    NoSession: 'noSession',
    NotAuthenticated: 'notAuthenticated',
    NotAuthorized: 'notAuthorized',
    NotAuthorizedDeviceType: 'notAuthorizedDeviceType',
    NotAuthorizedOutOfHome: 'notAuthorizedOutOfHome',
    NotAuthorizedOutOfRegion: 'notAuthorizedOutOfRegion',
    NotRegistered: 'notRegistered',
    TooManyStreams: 'tooManyStreams',
    TooManyStreamsForResource: 'tooManyStreamsForResource',
    UnknownLocation: 'unknownLocation'
};
exports.SessionStateStatusEnum = {
    Closed: 'closed',
    Created: 'created',
    Expired: 'expired',
    Failed: 'failed',
    Paused: 'paused',
    Streaming: 'streaming',
    StreamingNotPaused: 'streamingNotPaused'
};
